import Base64ToBlobService from "./Base64ToBlobService";
import GetImageWatermarkService from "./GetImageWatermarkService";
class WatermarkImageService {
    __watermarkImage = new GetImageWatermarkService();
    __base64ToBlobImage = new Base64ToBlobService();

    get watermarkImage() {
        return this.__watermarkImage;
    }

    get base64ToBlobImage() {
        return this.__base64ToBlobImage;
    }
}
export default new WatermarkImageService();
